<!-- <p style="display:block;position:absolute;z-index: 999;">...29</p> -->
<!-- <div class="statusbar-spacer"></div> -->
<router-outlet></router-outlet>
@if(/^(ios|android)$/.test(this.platformName)) {
<iframe id="recaptcha-frame" src="./assets/recaptcha-proxy.html" style="display: none;"></iframe>
}
